import { Admin } from "./types";

const defaultState = {
    cpties: [],
    selectedCpty: null,
    loading: false,
    error: null,
    onboardStatus: null, // { jobId, cptyCode, status, progress, errors }
    featureFlags: [],
    flagsLoading: false,
    flagsError: null,
    users: [],
    usersLoading: false,
    usersError: null,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case Admin.SET_CPTIES:
            return {
                ...state,
                cpties: action.cpties,
                purgeGraceSecs: action.purgeGraceSecs ?? state.purgeGraceSecs,
                error: null,
            };

        case Admin.SET_SELECTED_CPTY:
            return { ...state, selectedCpty: action.cpty, error: null };

        case Admin.SET_LOADING:
            return { ...state, loading: action.loading };

        case Admin.SET_ERROR:
            return { ...state, error: action.error, loading: false };

        case Admin.SET_ONBOARD_STATUS:
            return { ...state, onboardStatus: action.onboardStatus };

        case Admin.SET_FEATURE_FLAGS:
            return { ...state, featureFlags: action.flags, flagsError: null };

        case Admin.SET_FLAGS_LOADING:
            return { ...state, flagsLoading: action.loading };

        case Admin.SET_FLAGS_ERROR:
            return { ...state, flagsError: action.error, flagsLoading: false };

        case Admin.SET_USERS:
            return { ...state, users: action.users, usersError: null };

        case Admin.SET_USERS_LOADING:
            return { ...state, usersLoading: action.loading };

        case Admin.SET_USERS_ERROR:
            return { ...state, usersError: action.error, usersLoading: false };

        default:
            return state;
    }
};
